import type { LectureContent, LectureSnapshot } from '@wx-weiqi/contracts';
/** A small, explicit text syntax; HTML is always treated as literal text. */
export function lectureContent(text: string): LectureContent {
  return text
    .replace(/\r\n?/gu, '\n')
    .split('\n')
    .map((line) => {
      const bullet = line.startsWith('- '),
        body = bullet ? line.slice(2) : line;
      const runs: LectureContent[number]['runs'] = [];
      const pattern = /\*\*([^*]+)\*\*/gu;
      let from = 0;
      for (const match of body.matchAll(pattern)) {
        if (match.index > from) runs.push({ text: body.slice(from, match.index), bold: false });
        runs.push({ text: match[1]!, bold: true });
        from = match.index + match[0].length;
      }
      if (from < body.length || runs.length === 0)
        runs.push({ text: body.slice(from), bold: false });
      return { kind: bullet ? 'BULLET' : 'PARAGRAPH', runs };
    });
}
export function lectureText(content: LectureContent) {
  return content
    .map(
      (b) =>
        (b.kind === 'BULLET' ? '- ' : '') +
        b.runs.map((r) => (r.bold ? `**${r.text}**` : r.text)).join(''),
    )
    .join('\n');
}
export function lecturePositionLabel(
  s: Pick<LectureSnapshot, 'baseMove' | 'moveNumber' | 'variation'>,
) {
  return s.variation.length
    ? `主线第 ${s.baseMove} 手 · 变化 ${s.variation.length} 手`
    : `第 ${s.moveNumber} 手`;
}
export function lectureSnapshotKey(s: LectureSnapshot) {
  const { capturedAt: _, ...position } = s;
  void _;
  return JSON.stringify(position);
}
